<template>
  <div class="hawkEyeOfParkList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select
            v-model="pageSize"
            value="0"
            @change="changeSize"
            v-if="hidepage && tableData.length > 0"
          >
            <el-option
              v-for="(item, index) in $t('lang.SIZELIST.LIST')"
              :key="index"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="chooseOne"
            class="wid-280"
            :value="0"
            @change="chooseVideo()"
          >
            <el-option
              key
              :label="$t('lang.lab_chooseVideo')"
              :value="0"
              v-if="tableData.length > 0"
            ></el-option>
            <el-option
              key
              :label="$t('lang.lab_noEye')"
              :value="0"
              v-if="tableData.length === 0"
            ></el-option>
            <el-option
              v-for="(item, index) in allData"
              :key="index"
              :label="item.monitorPositionName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <el-card v-if="tableData.length > 0">
      <!-- <el-button
        v-if="this.chooseOne !== 0"
        type="primary"
        slot="header"
        @click="playRotate()"
        >鹰眼云台</el-button
      > -->
      <el-button
        v-if="this.chooseOne !== 0"
        type="primary"
        slot="header"
        @click="playBack()"
        >鹰眼回放</el-button
      >
      <!-- <el-button v-if="this.chooseOne !== 0" type="primary" slot="header" @click="startCrop()">{{$t('lang.lab_cutImg')}}</el-button> -->
      <el-button type="primary" slot="header" @click="jump()">{{
        $t("lang.lab_jump")
      }}</el-button>
      <div class="img-box" ref="imageWrapper">
        <el-card v-for="(item, index) in tableData" :key="index" class="video">
          <div
            :id="item.streamid"
            :style="{ width: changeFour + 'px', height: changeHeight + 'px' }"
          >
          <JessibucaDemo style="width:100%;height:100%"  :videoUrl="item.href" :videoId="item.streamid"/>
        </div>
          
          <!-- <video autoplay controls playsInline webkit-playsinline :width="changeFour" :id="'video' + item.id">
            <source :src="item.videoURL">
          </video> -->
          <div>{{ item.monitorPositionName }}</div>
        </el-card>
      </div>
      <el-pagination
        v-if="tableData.length > 0 && hidepage"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[4, 9]"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    <div id="video-container" display="none"></div>
  </div>
</template>

<script>
/**
 *@ClassName:hawkEyeOfParkList
 *@Description:园区鹰眼 监控
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-05-8
 */
import html2canvas from 'html2canvas'
import { mapGetters } from 'vuex'
// import '../../../config/niuniucapture.js'
// import '../../../config/capturewrapper.js'
import JessibucaDemo from '../../../components/jessibucaDemo.vue'
export default {
  name: '/manage/main.supplyVideo',
  components: { JessibucaDemo },
  data() {
    return {
      imgUrl: '',
      changeFour: 0, // 判断四宫格还是九宫格
      changeHeight: 0,
      videoSizeList: [], // 储存页码
      allData: [], // 全部视频的url
      tableData: [], // 存储视频url的数组
      pageNo: 1, // 页数
      pageSize: 4, // 每页显示数量
      pageCount: 0, // 总页数
      chooseOne: 0, // 单个鹰眼位置的url
      hidepage: true, // 是否隐藏四宫格
      allVideo: [], // 所有下拉列表
      allVideoId: '', // 临时的视频存放
      screenWidth: '',
      pbVideoURL: '', // 回放地址
      pbYsNumber: '', // 回放YsNumber
      pbTdNumber: '', // 回放TdNumber
    }
  },
  created() {
    this.getVideo()
    this.getAllVideo()
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return () => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      }
    }
  },
  computed: {
    ...mapGetters(['gardenId']),
  },
  watch: {
    gardenId: function(newFlag, oldFlag) {
      this.getVideo()
      this.chooseVideo()
    },
    screenWidth(val) {
      this.getVideo()
    },
    $route(newVal, oldVal) {
      let that = this
      setTimeout(() => {
        if (newVal.name == 'hawkEyeOfParkList') {
          that.getVideo()
          that.chooseVideo()
        }
      }, 500)
    },
  },
  methods: {
    // 获取鹰眼列表
    getVideo() {
      let loading = this.$loading()
      let width = document.body.clientWidth
      if (this.pageSize === 4) {
        this.changeFour = (width - 220 - 70 - 41 * 4) * 0.37
      } else {
        this.changeFour = (width - 220 - 70 - 41 * 6) * 0.3
      }
      this.changeHeight = (this.changeFour * 9) / 16
      this.$get(
        `/videoMonitorInterfaceList1?gardenId=${this.gardenId}&pageSize=${this.pageSize}&pageNo=${this.pageNo}`
      ).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            console.log(res)
            this.tableData = res.list
            console.log(res.list, 123213123213213)
            for (const item of this.tableData) {
              let streamid = item.streamId // 国标ID，在添加摄像头时需要进行配置
              item['streamid'] = streamid
              item['href'] = `https://mqtt.zlj365.com:281/gb28181/${streamid}.flv`
                // ' <iframe scrolling="no" width="100%" height="100%"  src="http://139.9.116.226/player/play_flv.html?type=live&appid=gb28181&streamid=' +
                // streamid +
                // '&domain=" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" ></iframe>';
            }

            this.allVideo = []
            for (let index = 0; index < res.list.length; index++) {
              this.allVideo.push(res.list[index].id)
            }
            this.pageCount = res.pageCount
            // setTimeout(() => {
            //   for (var i = 0; i < this.allVideo.length; i++) {
            //     // eslint-disable-next-line no-undef
            //     this.allVideo[i] = new EZUIKit1.EZUIPlayer(
            //       'video' + this.tableData[i].id
            //     );
            //     console.log(this.allVideo[i]);
            //   }
            // }, 1000);
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 获取全部鹰眼列表
    getAllVideo() {
      let loading = this.$loading()
      this.$get(
        `/videoMonitorInterfaceList1?gardenId=${this.gardenId}&pageSize=99999&pageNo=1`
      ).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.allData = res.list
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 选择一个鹰眼位置
    chooseVideo() {
      if (this.chooseOne === 0) {
        this.pbVideoURL = ''
        this.pbYsNumber = ''
        this.pbTdNumber = ''
        var redmine = this.chooseOne
        Object.assign(this.$data, this.$options.data.call(this))
        this.chooseOne = redmine
        this.getAllVideo()
        this.getVideo()
      } else {
        var redmines = this.chooseOne
        Object.assign(this.$data, this.$options.data.call(this))
        this.getAllVideo()
        this.chooseOne = redmines
        let loading = this.$loading()
        this.$get(
          `/videoMonitorInterfaceList1?gardenId=${this.gardenId}&pageSize=99999&pageNo=1`
        ).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.allData = res.list
              this.hidepage = false
              let newVideo = []
              for (var i = 0; i < this.allData.length; i++) {
                if (this.allData[i].id === this.chooseOne) {
                  newVideo.push(this.allData[i])
                }
              }
              this.tableData = newVideo
              for (const item of this.tableData) {
                let streamid = item.streamId // 国标ID，在添加摄像头时需要进行配置
                item['streamid'] = streamid
                item['href'] = `https://mqtt.zlj365.com:281/gb28181/${streamid}.flv`
              }
              // this.pbVideoURL = newVideo[0].videoURL
              // this.pbYsNumber = newVideo[0].YsNumber
              // this.pbTdNumber = newVideo[0].TdNumber

              // this.pageSize = 1
              this.changeFour = 1300
              this.changeHeight = (this.changeFour * 9) / 16

              // setTimeout(() => {
              //   // eslint-disable-next-line no-undef
              //   this.allVideoId = new EZUIKit1.EZUIPlayer('video' + this.tableData[0].id)
              //   this.allVideoId.stop()
              //   console.log(this.allVideoId)
              // }, 1000)
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      }
    },
    // 更改每页数量
    changeSize() {
      var pageC = this.pageSize
      Object.assign(this.$data, this.$options.data.call(this))
      this.pageSize = pageC
      this.getAllVideo()
      this.getVideo()
    },
    jump() {
      this.$router.push({
        name: 'repoInfoBackgroundSupply',
      })
    },
    startCrop() {
      // this.$message({
      //       type: 'warning',
      //       message: 'Window10请按Win + Shift + S来截图、Window7请按Win + Shift + S来截图'
      //     })
      const element = document.getElementById(this.tableData[0].streamid)
      console.log(element)
      html2canvas(element).then((canvas) => {
        let dataURL = canvas.toDataURL('image/png')
        this.imgUrl = dataURL
        if (this.imgUrl !== '') {
          console.log('截完的图片---', this.imgUrl)
          // 下载 图片 完成
          const link = document.createElement('a')
          link.href = this.imgUrl
          link.setAttribute('download', new Date() + '.png')
          link.style.display = 'none'
          document.body.appendChild(link)
          link.click()
          // 做个弹框是否上传 是就跳转 否就拉倒
        }
      })
      // let loading = this.$loading()
      // this.$confirm(
      //   this.$i18n.t('lang.lab_jump_info'),
      //   this.$i18n.t('lang.lab_prompt'),
      //   {
      //     confirmButtonText: this.$i18n.t('lang.btn_confirm'),
      //     cancelButtonText: this.$i18n.t('lang.btn_cancel'),
      //     type: 'warning'
      //   }
      // ).then(() => {
      //   this.$router.push({ name: 'repoInfoBackgroundSupply' })
      // }).catch(() => {
      //   loading.close()
      //   this.$message({
      //     type: 'info',
      //     message: this.$i18n.t('lang.lab_del_info')
      //   })
      // })
    },
    // 点击换页
    handleCurrentChange(val) {
      let pageD = this.pageSize
      Object.assign(this.$data, this.$options.data.call(this))
      this.pageNo = val
      this.pageSize = pageD
      this.getAllVideo()
      this.getVideo()
    },
    // 鹰眼回放
    playBack() {
      this.$router.push({
        name: 'videoRecord',
        query: {
          id: this.tableData[0].streamid,
          mediaIp: '139.9.116.226',
          mediaPort: '80',
        },
      })
    },
    // 鹰眼云台
    playRotate() {
      if (this.pbVideoURL == '') {
        this.$message.info('请选择鹰眼')
      } else {
        this.$router.push({
          name: 'hawkEyePlayBack',
          query: {
            state: 'playRotate',
            pbYsNumber: this.pbYsNumber,
            pbTdNumber: this.pbTdNumber,
          },
        })
      }
    },
  },
}
</script>

<style lang='scss'>
.hawkEyeOfParkList {
  .img-box {
    img {
      width: 500px;
      height: 500px;
    }
  }

  .wid-280 {
    width: 200px;
  }

  .video {
    display: inline-block;
    margin: 30px;
  }

  .showMessage {
    text-align: center;

    .errorMessage {
      font-size: 30px;
    }
  }

  .btn-right {
    text-align: right;
    padding-right: 95px;
    margin-top: 10px;
  }

  .sel-left {
    padding-left: 30px;
    margin-top: 10px;
  }
}
</style>
